import React from 'react';
import { CheckIcon, CloudLightningIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, productBrand, productEdition } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access'];
export function FinalCta() {
  return <section className="rain-texture border-t border-primary/40 bg-surface/70 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-58" data-mp="15dlu8ylzewt5">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-59" data-mp="1jc3eunglbt6u">
        <h2 id="final-title" className="text-balance font-display text-4xl font-extrabold uppercase tracking-tight text-foreground sm:text-5xl" data-id="element-60" data-mp="1ee1ulz7fhnts">
          <span className="inline-flex items-center gap-2" data-id="element-61" data-mp="1t1myhvc4nr2r">
            <CloudLightningIcon className="glow-led h-8 w-8 shrink-0 text-highlight" aria-hidden="true" data-id="element-62" data-mp="1o43leyr61kce" /> {productBrand}
          </span>
          <span className="mt-2 block text-2xl font-extrabold uppercase tracking-[.16em] text-accent sm:text-3xl" data-id="element-63" data-mp="224edg547p4z5">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-muted" data-id="element-64" data-mp="n649xjw7zkjt">
          Created for operations, HSE and engineering professionals worldwide.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full sm:w-auto" data-id="element-65" data-mp="s6iid31qgwid">
          Get my professional edition now
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-66" data-mp="1246dhu394612">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-67" data-mp="1b3a0381mn3kb">
              <CheckIcon className="glow-led h-4 w-4 text-highlight" aria-hidden="true" data-id="element-68" data-mp="1b1guzx6nwref" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}